export const PROVIDER_TYPE = "provider";
export const CONSUMER_TYPE = "consumer";
export const PAYER_TYPE = "payer";
export const DEVELOPER_TYPE = "developer"
export const CUSTOMER_SUPPORT_NUMBER = "Customer Service Contact #123-2314-7812";
